/* PSD geometry; editable text plus movable original raster words. */
const DESIGN_TEMPLATES = [
  {
    "key": "nk101",
    "sku": "NK-101",
    "name": "Script Wedding Names",
    "category": "wedding",
    "description": "Script Wedding Names. Fixed PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261024",
    "thumbnail": "design-templates-thumbs-NK-101-white.webp",
    "fixedTexture": "mr-fixed-101-v8.webp",
    "fields": [
      {
        "key": "name1",
        "label": "First name",
        "value": "Lucas",
        "prefix": "",
        "font": "Autography",
        "fontFile": "Autography.otf",
        "fontPostScript": "Autography",
        "size": 193.48293,
        "transform": [
          1.0408811241729723,
          0,
          0,
          1.040735684713413,
          577.3791935034576,
          418.4240883541672
        ],
        "bbox": [
          329,
          275,
          805,
          462
        ],
        "align": "center",
        "tracking": 100,
        "caps": 0,
        "maxWidth": 642.6,
        "maxLength": 48
      },
      {
        "key": "name2",
        "label": "Second name",
        "value": "Nicole",
        "prefix": "",
        "font": "Autography",
        "fontFile": "Autography.otf",
        "fontPostScript": "Autography",
        "size": 500,
        "transform": [
          0.4027854696938912,
          0,
          0,
          0.4027291895869027,
          610.2880181989769,
          790.1842808349254
        ],
        "bbox": [
          253,
          655,
          904,
          836
        ],
        "align": "center",
        "tracking": 100,
        "caps": 0,
        "maxWidth": 878.85,
        "maxLength": 48
      },
      {
        "key": "date",
        "label": "Date",
        "value": "August 28, 2026",
        "prefix": "",
        "font": "Athelas",
        "fontFile": "Athelas-Regular.ttf",
        "fontPostScript": "Athelas-Regular",
        "size": 150,
        "transform": [
          0.4027854696938912,
          0,
          0,
          0.4027291895869027,
          598.5619488578737,
          995.5246187917708
        ],
        "bbox": [
          326,
          956,
          857,
          1004
        ],
        "align": "center",
        "tracking": 100,
        "caps": 2,
        "maxWidth": 716.85,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed3",
        "label": "&",
        "asset": "mr-layer-101-3-v8.webp",
        "bbox": [
          545,
          530,
          605,
          588
        ]
      }
    ]
  },
  {
    "key": "nk102",
    "sku": "NK-102",
    "name": "Classic Wedding Names",
    "category": "wedding",
    "description": "Classic Wedding Names. Fixed PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261024",
    "thumbnail": "design-templates-thumbs-NK-102-white.webp",
    "fixedTexture": "mr-fixed-102-v8.webp",
    "fields": [
      {
        "key": "name1",
        "label": "First name",
        "value": "Charles",
        "prefix": "",
        "font": "Big Caslon",
        "fontFile": "BigCaslon-Web.ttf",
        "fontPostScript": "BigCaslon-Medium",
        "size": 130.98105,
        "transform": [
          0.9506564304611183,
          0,
          0,
          0.9505235978501104,
          561.0195868488705,
          409.1168217036392
        ],
        "bbox": [
          205,
          317,
          915,
          410
        ],
        "align": "center",
        "tracking": 100,
        "caps": 2,
        "maxWidth": 958.5,
        "maxLength": 48
      },
      {
        "key": "name2",
        "label": "Second name",
        "value": "ANNA",
        "prefix": "",
        "font": "Big Caslon",
        "fontFile": "BigCaslon-Web.ttf",
        "fontPostScript": "BigCaslon-Medium",
        "size": 338.48218,
        "transform": [
          0.36787159260385227,
          0,
          0,
          0.3678201909169805,
          560.1618773802634,
          794.2539843627833
        ],
        "bbox": [
          341,
          702,
          780,
          794
        ],
        "align": "center",
        "tracking": 100,
        "caps": 2,
        "maxWidth": 592.65,
        "maxLength": 48
      },
      {
        "key": "date",
        "label": "Date",
        "value": "October 21, 2026",
        "prefix": "",
        "font": "Playfair Display",
        "fontFile": "PlayfairDisplay-Regular.ttf",
        "fontPostScript": "PlayfairDisplay-Regular",
        "size": 166.66667,
        "transform": [
          0.36787159260385227,
          0,
          0,
          0.3678201909169805,
          566.4779443606086,
          934.6457186246228
        ],
        "bbox": [
          264,
          891,
          870,
          944
        ],
        "align": "center",
        "tracking": 100,
        "caps": 2,
        "maxWidth": 818.1,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed3",
        "label": "and",
        "asset": "mr-layer-102-3-v8.webp",
        "bbox": [
          351,
          505,
          785,
          607
        ]
      }
    ]
  },
  {
    "key": "nk103",
    "sku": "NK-103",
    "name": "Family Name & Date",
    "category": "wedding",
    "description": "Family Name & Date. Fixed PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261024",
    "thumbnail": "design-templates-thumbs-NK-103-white.webp",
    "fixedTexture": "mr-fixed-103-v8.webp",
    "fields": [
      {
        "key": "familyName",
        "label": "Family name",
        "value": "Sullivans",
        "prefix": "",
        "font": "Big Caslon",
        "fontFile": "BigCaslon-Web.ttf",
        "fontPostScript": "BigCaslon-Medium",
        "size": 200,
        "transform": [
          0.7345174350456096,
          0,
          0,
          0.7344148029425684,
          86.69852979412013,
          890.9634170351524
        ],
        "bbox": [
          96,
          783,
          1095,
          892
        ],
        "align": "left",
        "tracking": 100,
        "caps": 2,
        "maxWidth": 1348.65,
        "maxLength": 48
      },
      {
        "key": "date",
        "label": "Date",
        "value": "Oct 21, 2026",
        "prefix": "",
        "font": "Cardo",
        "fontFile": "Cardo-Regular.ttf",
        "fontPostScript": "Cardo-Regular",
        "size": 100,
        "transform": [
          0.7345174350456096,
          0,
          0,
          0.7344148029425684,
          311.0804898177852,
          1013.2172526249847
        ],
        "bbox": [
          101,
          961,
          523,
          1024
        ],
        "align": "center",
        "tracking": 0,
        "caps": 1,
        "maxWidth": 569.7,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed1",
        "label": "THE",
        "asset": "mr-layer-103-1-v8.webp",
        "bbox": [
          96,
          662,
          284,
          715
        ]
      }
    ]
  },
  {
    "key": "nk104",
    "sku": "NK-104",
    "name": "Mr & Mrs Family Name",
    "category": "wedding",
    "description": "Mr & Mrs Family Name. Fixed PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261024",
    "thumbnail": "design-templates-thumbs-NK-104-white.webp",
    "fixedTexture": "mr-fixed-104-v8.webp",
    "fields": [
      {
        "key": "familyName",
        "label": "Family name",
        "value": "Carters",
        "prefix": "",
        "font": "Angelta Script",
        "fontFile": "AngeltaScript.otf",
        "fontPostScript": "AngeltaScript",
        "size": 200,
        "transform": [
          1.248742244018404,
          0,
          0,
          1.2485677606956869,
          586.333587264097,
          829.6047920539795
        ],
        "bbox": [
          215,
          607,
          961,
          832
        ],
        "align": "center",
        "tracking": 0,
        "caps": 0,
        "maxWidth": 1007.1,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed1",
        "label": "Mr   MRS",
        "asset": "mr-layer-104-1-v8.webp",
        "bbox": [
          493,
          578,
          957,
          642
        ]
      },
      {
        "key": "fixed2",
        "label": "&",
        "asset": "mr-layer-104-2-v8.webp",
        "bbox": [
          672,
          594,
          727,
          643
        ]
      }
    ]
  },
  {
    "key": "nk105",
    "sku": "NK-105",
    "name": "Handwritten Mr & Mrs",
    "category": "wedding",
    "description": "Handwritten Mr & Mrs. Fixed PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261024",
    "thumbnail": "design-templates-thumbs-NK-105-white.webp",
    "fixedTexture": "mr-fixed-105-v8.webp",
    "fields": [
      {
        "key": "familyName",
        "label": "Family name",
        "value": "Bennetts",
        "prefix": "",
        "font": "Big Caslon",
        "fontFile": "BigCaslon-Web.ttf",
        "fontPostScript": "BigCaslon-Medium",
        "size": 130,
        "transform": [
          1.0335908004709797,
          0,
          0,
          1.0334463796683206,
          140.13271736801812,
          916.7942103290366
        ],
        "bbox": [
          145,
          819,
          1034,
          918
        ],
        "align": "left",
        "tracking": 100,
        "caps": 2,
        "maxWidth": 1200.15,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed1",
        "label": "Mr & Mrs",
        "asset": "mr-layer-105-1-v8.webp",
        "bbox": [
          140,
          645,
          696,
          752
        ]
      }
    ]
  },
  {
    "key": "nk106",
    "sku": "NK-106",
    "name": "Script Couple & Date",
    "category": "wedding",
    "description": "Script Couple & Date. Fixed PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261024",
    "thumbnail": "design-templates-thumbs-NK-106-white.webp",
    "fixedTexture": "mr-fixed-106-v8.webp",
    "fields": [
      {
        "key": "name1",
        "label": "First name",
        "value": "Ryan",
        "prefix": "",
        "font": "Autography",
        "fontFile": "Autography.otf",
        "fontPostScript": "Autography",
        "size": 118.35609,
        "transform": [
          1.084545933413025,
          0,
          0,
          1.0843943927896442,
          615.0625425480424,
          439.77872846889
        ],
        "bbox": [
          427,
          346,
          802,
          488
        ],
        "align": "center",
        "tracking": 100,
        "caps": 0,
        "maxWidth": 506.25,
        "maxLength": 48
      },
      {
        "key": "name2",
        "label": "Second name",
        "value": "Chloe",
        "prefix": "",
        "font": "Autography",
        "fontFile": "Autography.otf",
        "fontPostScript": "Autography",
        "size": 113.69308,
        "transform": [
          1.129027550678339,
          0,
          0,
          1.1288697947607953,
          623.1611099120263,
          782.3804802646299
        ],
        "bbox": [
          443,
          694,
          802,
          810
        ],
        "align": "center",
        "tracking": 100,
        "caps": 0,
        "maxWidth": 484.65,
        "maxLength": 48
      },
      {
        "key": "date",
        "label": "Date",
        "value": "02.10.2026",
        "prefix": "",
        "font": "Big Caslon",
        "fontFile": "BigCaslon-Web.ttf",
        "fontPostScript": "BigCaslon-Medium",
        "size": 100,
        "transform": [
          0.8335234918010723,
          0,
          0,
          0.8334070258537496,
          613.7337111102139,
          933.2411193870748
        ],
        "bbox": [
          402,
          873,
          825,
          933
        ],
        "align": "center",
        "tracking": 100,
        "caps": 0,
        "maxWidth": 571.05,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed3",
        "label": "&",
        "asset": "mr-layer-106-3-v8.webp",
        "bbox": [
          594,
          571,
          651,
          633
        ]
      }
    ]
  },
  {
    "key": "nk107",
    "sku": "NK-107",
    "name": "Best Day Ever",
    "category": "wedding",
    "description": "Best Day Ever. Fixed PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261024",
    "thumbnail": "design-templates-thumbs-NK-107-white.webp",
    "fixedTexture": "mr-fixed-107-v8.webp",
    "fields": [
      {
        "key": "name1",
        "label": "First name",
        "value": "Nathan",
        "prefix": "",
        "font": "Big Caslon",
        "fontFile": "BigCaslon-Web.ttf",
        "fontPostScript": "BigCaslon-Medium",
        "size": 100,
        "transform": [
          0.7345174350456096,
          0,
          0,
          0.7344148029425684,
          539.3513626101092,
          710.9329080519303
        ],
        "bbox": [
          180,
          657,
          537,
          711
        ],
        "align": "right",
        "tracking": 25,
        "caps": 2,
        "maxWidth": 481.95,
        "maxLength": 48
      },
      {
        "key": "name2",
        "label": "Second name",
        "value": "Jessica",
        "prefix": "",
        "font": "Big Caslon",
        "fontFile": "BigCaslon-Web.ttf",
        "fontPostScript": "BigCaslon-Medium",
        "size": 100,
        "transform": [
          0.7345174350456096,
          0,
          0,
          0.7344148029425684,
          689.7806665331032,
          709.1747971618147
        ],
        "bbox": [
          690,
          655,
          1012,
          710
        ],
        "align": "left",
        "tracking": 25,
        "caps": 2,
        "maxWidth": 434.7,
        "maxLength": 48
      },
      {
        "key": "date",
        "label": "Date",
        "value": "09.10.2026",
        "prefix": "",
        "font": "Big Caslon",
        "fontFile": "BigCaslon-Web.ttf",
        "fontPostScript": "BigCaslon-Medium",
        "size": 100,
        "transform": [
          0.7345174350456096,
          0,
          0,
          0.7344148029425684,
          429.13963990197544,
          835.1593789224196
        ],
        "bbox": [
          431,
          782,
          760,
          854
        ],
        "align": "left",
        "tracking": 25,
        "caps": 2,
        "maxWidth": 444.15,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed1",
        "label": "best day ever",
        "asset": "mr-layer-107-1-v8.webp",
        "bbox": [
          177,
          441,
          1008,
          580
        ]
      },
      {
        "key": "fixed4",
        "label": "&",
        "asset": "mr-layer-107-4-v8.webp",
        "bbox": [
          594,
          662,
          639,
          702
        ]
      }
    ]
  },
  {
    "key": "nk108",
    "sku": "NK-108",
    "name": "Two Serif Initials",
    "category": "wedding",
    "description": "Two Serif Initials. Fixed PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261024",
    "thumbnail": "design-templates-thumbs-NK-108-white.webp",
    "fixedTexture": "design-templates-fixed-NK-108-fixed.webp",
    "fields": [
      {
        "key": "initial1",
        "label": "Initial 1",
        "value": "E",
        "prefix": "",
        "font": "Athelas",
        "fontFile": "Athelas-Regular.ttf",
        "fontPostScript": "Athelas-Regular",
        "size": 100,
        "transform": [
          2.477346780228615,
          -1.3800544879749489e-15,
          0,
          2.4770006273697622,
          321.089956457148,
          729.668550741151
        ],
        "bbox": [
          257,
          567,
          388,
          731
        ],
        "align": "center",
        "tracking": 100,
        "caps": 0,
        "maxWidth": 189.95,
        "maxLength": 1
      },
      {
        "key": "initial2",
        "label": "Initial 2",
        "value": "T",
        "prefix": "",
        "font": "Athelas",
        "fontFile": "Athelas-Regular.ttf",
        "fontPostScript": "Athelas-Regular",
        "size": 100,
        "transform": [
          2.477346780228615,
          -1.3800544879749489e-15,
          0,
          2.4770006273697622,
          611.2243433001638,
          729.668550741151
        ],
        "bbox": [
          532,
          567,
          691,
          731
        ],
        "align": "center",
        "tracking": 100,
        "caps": 0,
        "maxWidth": 230.55,
        "maxLength": 1
      }
    ],
    "fixedText": [],
    "staticLayers": []
  },
  {
    "key": "nk109",
    "sku": "NK-109",
    "name": "Signature Family Name",
    "category": "family",
    "description": "Signature Family Name. Fixed PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261024",
    "thumbnail": "design-templates-thumbs-NK-109-white.webp",
    "fixedTexture": "design-templates-fixed-NK-109-fixed.webp",
    "fields": [
      {
        "key": "familyName",
        "label": "Family name",
        "value": "Jacksons",
        "prefix": "",
        "font": "Brittany Signature",
        "fontFile": "BrittanySignature.ttf",
        "fontPostScript": "BrittanySignatureRegular",
        "size": 300,
        "transform": [
          0.6540542554019474,
          0,
          0,
          0.6539628661979174,
          492.0612617271237,
          818.7257958015557
        ],
        "bbox": [
          161,
          630,
          842,
          942
        ],
        "align": "center",
        "tracking": 20,
        "caps": 0,
        "maxWidth": 919.35,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": []
  },
  {
    "key": "nk110",
    "sku": "NK-110",
    "name": "Script Monogram",
    "category": "wedding",
    "description": "Script Monogram. Fixed PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261024",
    "thumbnail": "design-templates-thumbs-NK-110-white.webp",
    "fixedTexture": "design-templates-fixed-NK-110-fixed.webp",
    "fields": [
      {
        "key": "initial1",
        "label": "Initial 1",
        "value": "L",
        "prefix": "",
        "font": "Amellia",
        "fontFile": "Amellia.ttf",
        "fontPostScript": "Amellia",
        "size": 300,
        "transform": [
          0.9221623399838307,
          0,
          0,
          0.9220334887737947,
          411.25416365141655,
          745.045380097507
        ],
        "bbox": [
          335,
          530,
          477,
          785
        ],
        "align": "center",
        "tracking": 100,
        "caps": 0,
        "maxWidth": 205.9,
        "maxLength": 1
      },
      {
        "key": "initial2",
        "label": "Initial 2",
        "value": "T",
        "prefix": "",
        "font": "Amellia",
        "fontFile": "Amellia.ttf",
        "fontPostScript": "Amellia",
        "size": 300,
        "transform": [
          0.9221623399838307,
          0,
          0,
          0.9220334887737947,
          595.8824111047794,
          868.935851808546
        ],
        "bbox": [
          517,
          657,
          739,
          911
        ],
        "align": "center",
        "tracking": 100,
        "caps": 0,
        "maxWidth": 321.9,
        "maxLength": 1
      }
    ],
    "fixedText": [],
    "staticLayers": []
  },
  {
    "key": "nk111",
    "sku": "NK-111",
    "name": "Monogram with Names",
    "category": "wedding",
    "description": "Monogram with Names. Fixed PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261024",
    "thumbnail": "design-templates-thumbs-NK-111-white.webp",
    "fixedTexture": "design-templates-fixed-NK-111-fixed.webp",
    "fields": [
      {
        "key": "initial1",
        "label": "Initial 1",
        "value": "A",
        "prefix": "",
        "font": "Athelas",
        "fontFile": "Athelas-Regular.ttf",
        "fontPostScript": "Athelas-Regular",
        "size": 100,
        "transform": [
          2.477346780228615,
          -1.3800544879749489e-15,
          0,
          2.4770006273697622,
          416.5772230130773,
          617.3030858909381
        ],
        "bbox": [
          332,
          453,
          501,
          618
        ],
        "align": "center",
        "tracking": 100,
        "caps": 0,
        "maxWidth": 245.05,
        "maxLength": 1
      },
      {
        "key": "initial2",
        "label": "Initial 2",
        "value": "D",
        "prefix": "",
        "font": "Athelas",
        "fontFile": "Athelas-Regular.ttf",
        "fontPostScript": "Athelas-Regular",
        "size": 100,
        "transform": [
          2.477346780228615,
          -1.3800544879749489e-15,
          0,
          2.4770006273697622,
          709.6496795962755,
          619.5063302997658
        ],
        "bbox": [
          627,
          458,
          793,
          621
        ],
        "align": "center",
        "tracking": 100,
        "caps": 0,
        "maxWidth": 240.7,
        "maxLength": 1
      },
      {
        "key": "names",
        "label": "Names",
        "value": "Amelia & DANIEL",
        "prefix": "",
        "font": "Athelas",
        "fontFile": "Athelas-Regular.ttf",
        "fontPostScript": "Athelas-Regular",
        "size": 80,
        "transform": [
          0.7345174350456096,
          0,
          0,
          0.7344148029425684,
          561.9508733174093,
          788.0527939175964
        ],
        "bbox": [
          304,
          749,
          820,
          789
        ],
        "align": "center",
        "tracking": 20,
        "caps": 2,
        "maxWidth": 696.6,
        "maxLength": 48
      },
      {
        "key": "date",
        "label": "Date",
        "value": "09.21.2026",
        "prefix": "",
        "font": "Bodoni Bk BT",
        "fontFile": "BodoniBT-Book.ttf",
        "fontPostScript": "BodoniBT-Book",
        "size": 80,
        "transform": [
          0.7345174350456096,
          0,
          0,
          0.7344148029425684,
          561.9706550833978,
          877.3097507535774
        ],
        "bbox": [
          425,
          840,
          698,
          877
        ],
        "align": "center",
        "tracking": 20,
        "caps": 2,
        "maxWidth": 368.55,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": []
  },
  {
    "key": "nk112",
    "sku": "NK-112",
    "name": "Family Name with Heart",
    "category": "family",
    "description": "Family Name with Heart. Fixed PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261024",
    "thumbnail": "design-templates-thumbs-NK-112-white.webp",
    "fixedTexture": "mr-fixed-112-v8.webp",
    "fields": [
      {
        "key": "familyName",
        "label": "Family name",
        "value": "Masons",
        "prefix": "",
        "font": "Brittany Signature",
        "fontFile": "BrittanySignature.ttf",
        "fontPostScript": "BrittanySignatureRegular",
        "size": 300,
        "transform": [
          0.6245770588083688,
          -8.505512012755615e-17,
          0,
          0.6244897883720274,
          606.7033629371061,
          773.8445092600059
        ],
        "bbox": [
          307,
          595,
          918,
          896
        ],
        "align": "center",
        "tracking": 20,
        "caps": 0,
        "maxWidth": 824.85,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed1",
        "label": "The",
        "asset": "mr-layer-112-1-v8.webp",
        "bbox": [
          567,
          374,
          776,
          654
        ]
      }
    ]
  },
  {
    "key": "nk113",
    "sku": "NK-113",
    "name": "Better Together",
    "category": "wedding",
    "description": "Better Together. Fixed PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261024",
    "thumbnail": "design-templates-thumbs-NK-113-white.webp",
    "fixedTexture": "mr-fixed-113-v8.webp",
    "fields": [
      {
        "key": "name1",
        "label": "First name",
        "value": "William",
        "prefix": "",
        "font": "Bacalisties",
        "fontFile": "Bacalisties.ttf",
        "fontPostScript": "Bacalisties",
        "size": 180,
        "transform": [
          0.7345174350456096,
          0,
          0,
          0.7344148029425684,
          387.01338920442527,
          775.3563303098442
        ],
        "bbox": [
          156,
          688,
          620,
          854
        ],
        "align": "center",
        "tracking": 0,
        "caps": 0,
        "maxWidth": 626.4,
        "maxLength": 48
      },
      {
        "key": "name2",
        "label": "Second name",
        "value": "Claire",
        "prefix": "",
        "font": "Bacalisties",
        "fontFile": "Bacalisties.ttf",
        "fontPostScript": "Bacalisties",
        "size": 180,
        "transform": [
          0.7345174350456096,
          0,
          0,
          0.7344148029425684,
          941.1728445065066,
          765.0974048172804
        ],
        "bbox": [
          758,
          679,
          1132,
          845
        ],
        "align": "center",
        "tracking": 0,
        "caps": 0,
        "maxWidth": 504.9,
        "maxLength": 48
      },
      {
        "key": "date",
        "label": "Date",
        "value": "09.09.2026",
        "prefix": "",
        "font": "Bodoni Bk BT",
        "fontFile": "BodoniBT-Book.ttf",
        "fontPostScript": "BodoniBT-Book",
        "size": 90,
        "transform": [
          0.7345174350456096,
          0,
          0,
          0.7344148029425684,
          644.8381488809977,
          952.7973497919256
        ],
        "bbox": [
          491,
          911,
          798,
          953
        ],
        "align": "center",
        "tracking": 20,
        "caps": 2,
        "maxWidth": 414.45,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed1",
        "label": "BETTER TOGETHER",
        "asset": "mr-layer-113-1-v8.webp",
        "bbox": [
          375,
          363,
          875,
          510
        ]
      },
      {
        "key": "fixed6",
        "label": "&",
        "asset": "mr-layer-113-6-v8.webp",
        "bbox": [
          628,
          716,
          708,
          814
        ]
      }
    ]
  },
  {
    "key": "nk114",
    "sku": "NK-114",
    "name": "Ornate Initials",
    "category": "wedding",
    "description": "Ornate Initials. Fixed PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261024",
    "thumbnail": "design-templates-thumbs-NK-114-white.webp",
    "fixedTexture": "design-templates-fixed-NK-114-fixed.webp",
    "fields": [
      {
        "key": "initial1",
        "label": "Initial 1",
        "value": "D",
        "prefix": "",
        "font": "Tempting",
        "fontFile": "Tempting.ttf",
        "fontPostScript": "Tempting",
        "size": 88.94807,
        "transform": [
          2.477346780228615,
          -1.3800544879749489e-15,
          0,
          2.4770006273697622,
          441.550815804628,
          578.3791013349819
        ],
        "bbox": [
          263,
          324,
          687,
          604
        ],
        "align": "center",
        "tracking": 100,
        "caps": 0,
        "maxWidth": 614.8,
        "maxLength": 1
      },
      {
        "key": "initial2",
        "label": "Initial 2",
        "value": "M",
        "prefix": "",
        "font": "Tempting",
        "fontFile": "Tempting.ttf",
        "fontPostScript": "Tempting",
        "size": 88.94807,
        "transform": [
          2.477346780228615,
          -1.3800544879749489e-15,
          0,
          2.4770006273697622,
          661.1715288832653,
          752.4354096323707
        ],
        "bbox": [
          499,
          501,
          944,
          782
        ],
        "align": "center",
        "tracking": 100,
        "caps": 0,
        "maxWidth": 645.25,
        "maxLength": 1
      },
      {
        "key": "names",
        "label": "Names",
        "value": "Daniel & Madison",
        "prefix": "",
        "font": "Big Caslon",
        "fontFile": "BigCaslon-Web.ttf",
        "fontPostScript": "BigCaslon-Medium",
        "size": 90,
        "transform": [
          0.7345174350456096,
          0,
          0,
          0.7344148029425684,
          601.6148148098723,
          887.1987923148431
        ],
        "bbox": [
          238,
          839,
          965,
          888
        ],
        "align": "center",
        "tracking": 20,
        "caps": 2,
        "maxWidth": 981.45,
        "maxLength": 48
      },
      {
        "key": "date",
        "label": "Date",
        "value": "09.09.2026",
        "prefix": "",
        "font": "Bodoni Bk BT",
        "fontFile": "BodoniBT-Book.ttf",
        "fontPostScript": "BodoniBT-Book",
        "size": 90,
        "transform": [
          0.7345174350456096,
          0,
          0,
          0.7344148029425684,
          602.3691140109064,
          987.6128748155609
        ],
        "bbox": [
          449,
          946,
          756,
          988
        ],
        "align": "center",
        "tracking": 20,
        "caps": 2,
        "maxWidth": 414.45,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": []
  },
  {
    "key": "nk115",
    "sku": "NK-115",
    "name": "Family Name with Laurel",
    "category": "family",
    "description": "Family Name with Laurel. Fixed PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261024",
    "thumbnail": "design-templates-thumbs-NK-115-white.webp",
    "fixedTexture": "mr-fixed-115-v8.webp",
    "fields": [
      {
        "key": "familyName",
        "label": "Family name",
        "value": "Masons",
        "prefix": "",
        "font": "Brittany Signature",
        "fontFile": "BrittanySignature.ttf",
        "fontPostScript": "BrittanySignatureRegular",
        "size": 120,
        "transform": [
          1.6784219261048334,
          0,
          0,
          1.678187404820725,
          603.4936611956268,
          631.9984078157362
        ],
        "bbox": [
          281,
          440,
          939,
          763
        ],
        "align": "center",
        "tracking": 20,
        "caps": 0,
        "maxWidth": 888.3,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": [
      {
        "key": "fixed2",
        "label": "The",
        "asset": "mr-layer-115-2-v8.webp",
        "bbox": [
          607,
          439,
          755,
          491
        ]
      }
    ]
  },
  {
    "key": "nk116",
    "sku": "NK-116",
    "name": "Couple, Family & Date",
    "category": "wedding",
    "description": "Couple, Family & Date. Fixed PSD layout; personalize the text.",
    "canvasSize": 1476,
    "version": "psd1476-20261024",
    "thumbnail": "design-templates-thumbs-NK-116-white.webp",
    "fixedTexture": "design-templates-fixed-NK-116-fixed.webp",
    "fields": [
      {
        "key": "name1",
        "label": "First name",
        "value": "Marcus",
        "prefix": "",
        "font": "Brittany Signature",
        "fontFile": "BrittanySignature.ttf",
        "fontPostScript": "BrittanySignatureRegular",
        "size": 604.16669,
        "transform": [
          0.33563023336415077,
          0,
          0,
          0.22109173556009803,
          202.17038194012525,
          545.5535378949032
        ],
        "bbox": [
          204,
          418,
          839,
          633
        ],
        "align": "left",
        "tracking": 0,
        "caps": 0,
        "maxWidth": 857.25,
        "maxLength": 48
      },
      {
        "key": "name2",
        "label": "Second name",
        "value": "Steve",
        "prefix": "& ",
        "font": "Brittany Signature",
        "fontFile": "BrittanySignature.ttf",
        "fontPostScript": "BrittanySignatureRegular",
        "size": 645.83331,
        "transform": [
          0.24580669710313183,
          0,
          0,
          0.2660105956752818,
          210.61165068560496,
          786.8008697546095
        ],
        "bbox": [
          212,
          620,
          679,
          895
        ],
        "align": "left",
        "tracking": 0,
        "caps": 0,
        "maxWidth": 630.45,
        "maxLength": 48
      },
      {
        "key": "familyName",
        "label": "Family name",
        "value": "THE WALKER",
        "prefix": "",
        "font": "Times New Roman PSD Bold",
        "fontFile": "TimesNewRoman-Bold.ttf",
        "fontPostScript": "TimesNewRomanPS-BoldMT",
        "size": 150,
        "transform": [
          0.3281291451605102,
          0,
          0,
          0.35010740676347957,
          208.92339693650905,
          960.9310826652338
        ],
        "bbox": [
          210,
          925,
          572,
          962
        ],
        "align": "left",
        "tracking": 65,
        "caps": 0,
        "maxWidth": 488.7,
        "maxLength": 48
      },
      {
        "key": "date",
        "label": "Date",
        "value": "12.10.2026",
        "prefix": "",
        "font": "Times New Roman PSD Bold",
        "fontFile": "TimesNewRoman-Bold.ttf",
        "fontPostScript": "TimesNewRomanPS-BoldMT",
        "size": 30,
        "transform": [
          1.6882537490959286,
          0,
          0,
          1.6880178540382078,
          207.73186206862925,
          1026.9950852744441
        ],
        "bbox": [
          211,
          992,
          464,
          1028
        ],
        "align": "left",
        "tracking": 65,
        "caps": 0,
        "maxWidth": 341.55,
        "maxLength": 48
      }
    ],
    "fixedText": [],
    "staticLayers": []
  }
];
